import { useFeatureFlagToggles } from '@clarity-website/app/ConfigurationContext';
import { lazy, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useHistory } from 'react-router-dom';

// Dynamically import the AZA component
const AzaGlobalFab = lazy(() => import('atozassistant/AzaGlobalFab'));
const ClarityAssistDragAndDrop = lazy(
  () =>
    import(
      /* webpackChunkName: "clarity-assist-app" */ '@clarity-website/app/ClarityAssistDragAndDrop'
    ),
);

function AzaFabWrapper(): JSX.Element {
  const { isFeatureFlagToggleOn: useAzaGlobalFab } = useFeatureFlagToggles(
    'aza-mfe-integration',
  );

  const ClarityAssist = <ClarityAssistDragAndDrop />;
  const history = useHistory();
  const handleLinkRedirection = (url: string) => {
    const targetUrl = new URL(url);
    if (targetUrl.host === window.location.host) {
      history.push(targetUrl.pathname + targetUrl.search + targetUrl.hash);
      return true;
    }
    return false;
  };

  return (
    <Suspense fallback={<span hidden />}>
      <ErrorBoundary fallback={ClarityAssist}>
        {useAzaGlobalFab ? (
          <AzaGlobalFab
            customDevApiEndPoint={`https://${window.location.host}/apis/AtoZAssistant`}
            showFab
            handleLinkRedirection={handleLinkRedirection}
          />
        ) : (
          ClarityAssist
        )}
      </ErrorBoundary>
    </Suspense>
  );
}

export default AzaFabWrapper;
